var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9312 8.57389V8.57389C13.0527 8.84237 13.0056 9.15711 12.8108 9.37827L4.56697 18.7533V18.7533C4.29339 19.064 3.81973 19.0941 3.50903 18.8205C3.27654 18.6158 3.19393 18.2891 3.30112 17.9985L5.55258 11.8828H1.75597V11.8828C1.34176 11.8825 1.00619 11.5465 1.00647 11.1323C1.00659 10.9501 1.07299 10.7743 1.19328 10.6375L9.43751 1.26248V1.26248C9.711 0.951724 10.1846 0.92151 10.4954 1.195C10.728 1.39973 10.8107 1.72652 10.7034 2.01725L8.45171 8.13278H12.2484V8.13278C12.5429 8.13272 12.8102 8.30536 12.9312 8.57389V8.57389Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningCharge);
export default __webpack_public_path__ + "static/media/lightningCharge.908197e01df1dfc344120eae4d9d552f.svg";
export { ForwardRef as ReactComponent };